export const GAME_THEME = {
    TARGET_FILL: 'black',
    TARGET_STROKE: 'white',
    TARGET_STROKE_WIDTH: 1,
    BACKGROUND_COLOR: '#333',
    BUTTON_BG: 'black',
    BUTTON_COLOR: 'white',
    BUTTON_HOVER_BG: '#222',
    QUIT_BUTTON_BG: 'black',
    QUIT_BUTTON_HOVER_BG: '#111'
};
